import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M31.469 9.333H18.913l-12.58-8.1.01-.004C8.432.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.447 1.728 5.477 6.646 5.477 6.646q.17.71.302 1.424"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "m6.334 30.767 12.579-8.1H31.44q-.135.728-.308 1.457s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.967 16 32c-3.75-.034-7.567-.432-9.658-1.23z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "m4.954 1.93 13.567 8.737h13.162c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H18.52L4.954 30.07C1.674 27.988.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .808-3.863 4.088-5.944",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M.78 8.249 13.182 16 .777 23.753c-.625-2.67-.805-5.356-.774-7.77-.031-2.38.18-5.065.777-7.734"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.502 9.647 10.667 16 .49 22.36c-.394-2.203-.513-4.383-.487-6.377a34.4 34.4 0 0 1 .499-6.336",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagZaf = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagZaf_default = SvgFlagZaf;

export { FlagZaf_default as default };
